import styled from 'styled-components'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'
import { Heading, Button as BaseButton } from '..'
import landingPageBg from '../../../.ai/materials/landing_page_background_wide.png'

export const IntroContainer = styled.div`
  width: 100%;
  background: ${variables.colors.brandPrimary};
  padding: 96px 0 20px 0;
  position: relative;
  overflow: hidden;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-image: url(${landingPageBg});
    background-size: cover;
    background-position: right center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  @media ${variables.media.sm} {
    padding: 96px 0;
  }
`

export const IntroSection = styled(TextWrapper)`
  background: transparent;
  color: white;
  position: relative;
  z-index: 2;
  max-width: 1280px;
`

export const IntroHeader = styled(Heading)`
  ${headerStyles.headerMedium};
  word-wrap: nowrap;
  animation: slideUp 0.5s ease-in-out;
  color: white !important;
  
  @media (max-width: 768px) {
    font-size: 2.5rem !important; /* Make title significantly larger on mobile */
  }
`

export const PlainEnglishExplainer = styled.p`
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.3rem;
  font-weight: 500;
  max-width: 600px;
  margin: 1.5rem 0 2rem 0;
  line-height: 1.5;
  animation: slideUp 0.5s ease-in-out 0.1s;
  animation-fill-mode: forwards;
  opacity: 0;
  
  @media ${variables.media.sm} {
    font-size: 1.2rem;
  }
`

export const IntroTagline = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.2rem;
  max-width: 500px;
  animation: slideUp 0.5s ease-in-out 0.2s;
  animation-fill-mode: forwards;
  opacity: 0;
`

export const IntroSectionAnimationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
`

export const AnimationContainer = styled.div`
  margin: 20px;
  height: 400px;
`

export const KnowledgeGardenImage = styled.img`
  width: 100%;
  height: auto;
  max-width: none;
  animation: fadeIn 0.8s ease-in-out 0.3s;
  animation-fill-mode: forwards;
  opacity: 0;
  filter: none;
  
  @media ${variables.media.sm} {
    width: 100%;
    max-width: none;
  }
`

export const IntroSectionSideSquare = styled.img`
  display: none;
  visibility: hidden;

  @media ${variables.media.sm} {
    display: block;
    visibility: visible;
    position: absolute;
    bottom: -40px;
    right: 10px;
    transform: translate(50%, 50%) rotate(45deg);
    z-index: 1;
    height: 100px;
  }
`

export const ButtonContainer = styled.div`
  margin-top: 50px;
  animation: fadeIn 0.5s ease-in-out 0.3s;
  animation-fill-mode: forwards;
  opacity: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
  
  @media ${variables.media.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  
  @media ${variables.media.sm} {
    flex-direction: row;
    align-items: center;
    gap: 15px;
  }
`

export const PerformanceBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  
  @media ${variables.media.sm} {
    margin-left: auto;
  }
`

export const Button = styled(BaseButton)`
  /* Spacing handled by flex gap */
`

export const DemotedButton = styled(BaseButton)`
  opacity: 0.8;
  font-size: 0.85rem;
  /* Spacing handled by flex gap */
`

export const ComplianceNote = styled.div`
  font-size: 14px;
  color: ${variables.colors.coreViolet};
  margin-top: 40px;
  font-weight: 400;
  animation: fadeIn 0.5s ease-in-out 0.4s;
  animation-fill-mode: forwards;
  opacity: 0;
  background: transparent;
  padding: 0;
  border-radius: 0;
  display: inline-block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -80px;
  
  @media ${variables.media.sm} {
    position: static;
    transform: none;
    left: auto;
    bottom: auto;
  }
`

export const HeroQueryContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
  position: relative;
  z-index: 2;
  
  @media ${variables.media.sm} {
    padding: 40px;
  }
`
